<template>
  <div class="container">
    <div class="list">
      <a
        class="item"
        v-for="item in list"
        :key="item.article_id"
        :href="item.article_url"
      >
        <p class="text">{{ item.article_title }}</p>
        <img class="icon" src="../assets/img/right-arrow.png" />
      </a>
      <div class="foot">
        请点击
        <span class="green" @click="toHelpService">联系客服</span> 帮您解决哦
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "appHelpCenter",
  data() {
    return {
      list: [],
    };
  },
  created() {
    this.$ajax({
      headers: {
        "X-DEVICE-TYPE": "4",
        "X-APP-NAME": "musicwow",
        "Content-Type": "application/x-www-form-urlencoded",
      },
      url:
        process.env.VUE_APP_CONT_API +
        "api/v1/article/menu/help?page=1&page_size=50",
      method: "get",
    }).then((res) => {
      if (res.data.error_code === 0) {
        this.list = res.data.data.list;
      }
    });
  },
  methods: {
    toHelpService() {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //安卓端
      // let isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //IOS端
      try {
        if (isAndroid && App) {
          App.customerService();
        } else {
          window.webkit.messageHandlers.App.postMessage({
            function: "customerService",
          });
        }
      } catch (error) {
        // console.log(error);
      }
    },
  },
};
</script>
<style lang="sass" scoped>
.container
  min-height: 100vh
  background-color: #F5F6F9
  display: flex
.list
  border-top: 1px solid #F8F9FA
.list
  padding-bottom: 50px
  position: relative
  width: 100%
  .item
    display: flex
    height: 44px
    text-align: left
    background-color: #ffffff
    border-bottom: 1px solid #F8F9FA
    .text
      flex: 1
      line-height: 44px
      padding-left: 18px
      font-size: 14px
      color: #2C2C2F
    .icon
      width: 20px
      height: 20px
      margin: 12px
  .foot
    position: absolute
    bottom: 20px
    left: 0
    right: 0
    text-align: center
    font-size: 12px
    color: #959597
    .green
      color: #07D1AA
</style>